export enum ON_INVALID_DO {
    SILENT = "SILENT",
    TRANSFORM = "TRANSFORM", // doesn't make the validation invalid but instead calls a transformer if the entity is still valid, before add() is called
    RETURN_ERROR = "RETURN_ERROR",
    CONSOLE_LOG = "CONSOLE_LOG",
    CONSOLE_ERROR = "CONSOLE_ERROR",
    THROW = "THROW",
}